import React, { PropTypes, Component } from 'react';
import classes from '../index.scss';

class Success extends Component {
  submit = () => {
    this.props.callback('Close');
  }

  render() {
    return (
      <div className={classes['after-initial']}>
        <p className={classes['title']}>Your code is on its way.</p>
        <p className={classes['subtitle']}>Check your inbox soon for your special offer.</p>
          <div className={classes.button} onClick={this.submit}>
            <p>Continue Shopping</p>
          </div>
      </div>
    );
  }
}

Success.propTypes = {
  callback: PropTypes.func.isRequired,
};

export default Success;



/** WEBPACK FOOTER **
 ** ./apps/emailPromoModal/components/Success.js
 **/